const ua = navigator.userAgent || '';
const bootstrapRuntime = window.mobileRuntime || {};

const state = {
  isApp: Boolean(window.isClient || bootstrapRuntime.isApp) || /SSCM|CYKD/i.test(ua),
  isIOS: Boolean(bootstrapRuntime.isIOS) || /iPhone|iPad|iPod/i.test(ua),
  isAndroid: Boolean(bootstrapRuntime.isAndroid) || /Android/i.test(ua),
  isWeChat: Boolean(bootstrapRuntime.isWeChat) || /MicroMessenger/i.test(ua),
  isMiniProgram: Boolean(window.isMini || bootstrapRuntime.isMiniProgram),
  miniPlatform: window.miniPlatform || bootstrapRuntime.miniPlatform || '',
};

const mobileRuntime = Object.freeze({
  get isApp() { return state.isApp; },
  get isIOS() { return state.isIOS; },
  get isAndroid() { return state.isAndroid; },
  get isWeChat() { return state.isWeChat; },
  get isMiniProgram() { return state.isMiniProgram; },
  get miniPlatform() { return state.miniPlatform; },
  get supportsVisualViewport() { return Boolean(window.visualViewport); },
  get supportsDynamicViewport() { return Boolean(window.CSS && CSS.supports('height', '100dvh')); },
});

function applyRuntimeClasses() {
  const root = document.documentElement;
  root.classList.toggle('is-app', state.isApp);
  root.classList.toggle('is-ios', state.isIOS);
  root.classList.toggle('is-android', state.isAndroid);
  root.classList.toggle('is-mini-program', state.isMiniProgram);
}

function syncLegacyFlags() {
  window.isClient = state.isApp;
  window.isIOS = state.isIOS;
  window.isAndroid = state.isAndroid;
  window.isMini = state.isMiniProgram;
  window.miniPlatform = state.miniPlatform;
}

export function updateMobileRuntime(nextState = {}) {
  Object.keys(state).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(nextState, key)) state[key] = nextState[key];
  });
  syncLegacyFlags();
  applyRuntimeClasses();
}

export function installMobileViewport() {
  window.mobileRuntime = mobileRuntime;
  syncLegacyFlags();
  applyRuntimeClasses();

  const root = document.documentElement;
  const viewport = window.visualViewport;
  let frame = 0;
  const updateViewport = () => {
    frame = 0;
    const height = Math.round(viewport ? viewport.height : window.innerHeight);
    const layoutHeight = Math.round(window.innerHeight);
    root.style.setProperty('--visual-height', `${height}px`);
    root.style.setProperty('--keyboard-height', `${Math.max(0, layoutHeight - height)}px`);
    root.classList.toggle('is-keyboard-open', layoutHeight - height > 120);
  };
  const scheduleUpdate = () => {
    if (!frame) frame = window.requestAnimationFrame(updateViewport);
  };

  updateViewport();
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
  if (viewport) {
    viewport.addEventListener('resize', scheduleUpdate, { passive: true });
    viewport.addEventListener('scroll', scheduleUpdate, { passive: true });
  }
}

export default mobileRuntime;
